import { CacheConfig, RequestParameters, Variables } from 'relay-runtime';
import { RelayQueryResultCache } from './relayQueryResultCache';
import { getServerStream } from '@confluence/ssr-data-streaming/entry-points/server';
import { createIdentifierFromQuery } from '@confluence/graphql/entry-points/createIdentifierFromQuery';

export const SSR_NAMESPACE = 'relay';
let ssrQueryResultCache: RelayQueryResultCache | null = null;
let isSSRDataLinkEnabled = false;

export interface Event {
	type: 'result';
	operation: string;
	queryId: string;
	variables: Variables;
	result: any;
}

/**
 * Read the data from the global buffer for the query id to be used by useQueryInterop to read and put into the Relay store before using fetchQuery.
 */
export const readDataFromStream = (
	request: RequestParameters,
	variables: Variables,
): object | null => {
	if (window.__SSR_REACT_STREAMING__ && ssrQueryResultCache && request.text) {
		const queryIdentifier = createIdentifierFromQuery(request.text);
		const result = ssrQueryResultCache.getMatchingResult(queryIdentifier, variables);
		return result;
	}
	return null;
};

/**
 * Write the data from the response to the server stream.
 *
 */
export const writeDataToStream = (
	request: RequestParameters,
	variables: Variables,
	cacheConfig: CacheConfig,
	data: any,
) => {
	if (!isSSRDataLinkEnabled || !request.text) {
		return;
	}

	const serverStream = getServerStream(SSR_NAMESPACE);
	const query = (cacheConfig.metadata?.originalQuery as string) ?? request.text;
	if (query && typeof query === 'string') {
		const event: Event = {
			type: 'result',
			queryId: request.id ?? '',
			operation: createIdentifierFromQuery(query),
			variables,
			result: { data: data },
		};
		serverStream.emit(event);
	}
};

export function enableSSRDataLink(): void {
	isSSRDataLinkEnabled = true;
}

export function disableSSRDataLink(): void {
	isSSRDataLinkEnabled = false;
}

export const initializeSSR = (namespace: string): void => {
	if (window.__SSR_REACT_STREAMING__) {
		ssrQueryResultCache = new RelayQueryResultCache(namespace);
	}
};
